// Module
var code = "<a href=\"\" class=\"searchHeader\" data-ng-click=\"isopen = !isopen\">\r\n    <h5>{{::title}}</h5>\r\n    <span ng-class=\"isopen ? 'glyphicon-chevron-up' : 'glyphicon-chevron-down'\" class=\"glyphicon\"></span>\r\n</a>\r\n<div data-uib-collapse=\"!isopen\" ng-transclude=\"\">\r\n</div>\r\n";
// Exports
module.exports = code;